import { Component, Inject, OnInit } from '@angular/core';
import { MbDialogHeader, MbDialogBody, MB_DIALOG_DATA } from '@am/moebius';
import { IAccomodationFee } from '@core/models/modals';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';

@Component({
  selector: 'app-modal-accommodation-fee',
  standalone: true,
  imports: [MbDialogHeader, MbDialogBody],
  templateUrl: './accommodation-fee.component.html',
})
export class ModalAccommodationFeeComponent
  extends DialogWrapperComponent
  implements OnInit
{
  constructor(@Inject(MB_DIALOG_DATA) public dialogData: IAccomodationFee) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
